export const MAX_NUMBER_OF_APPLICATION_USERS = 5;
export const MAX_NUMBER_OF_APPLICATION_PERMISSIONS = MAX_NUMBER_OF_APPLICATION_USERS + 1;
export const applicationManagerTableHeaders = ['User', 'Role', ''];
export const userTableHeaders = ['User', 'Role', 'Application permission'];
export const PERMISSION_STATUS = {
  denied: 'DENIED',
  dismissed: 'DISMISSED',
  granted: 'GRANTED',
  pending: 'PENDING',
};
export const USER_MANAGEMENT_ROLE = {
  applicationManager: 'Application Manager',
  companyAdmin: 'Company Admin',
};
export const PERMISSION_REQUEST_TYPE = {
  NO_PERMISSION: 'NO_PERMISSION',
  REQUEST_ACCESS: 'REQUEST_ACCESS',
  SET_APPLICATION_MANAGER: 'SET_APPLICATION_MANAGER',
} as const;

export const PERMISSION_CARD_TEXT = {
  REQUEST_ACCESS: {
    subHeading: 'You need permission to access applications.',
    body: 'Applications contain confidential information such as credit score, background report, and income documents. If you want access, ask your account’s application manager to assign you permission.',
    buttonText: 'Request permission',
  },
  SET_APPLICATION_MANAGER: {
    subHeading: 'Your account doesn’t currently have an application manager.',
    body: 'An admin on your account needs to be assigned to the application manager role. They can then assign application permissions to up to 5 users on your account.',
    buttonText: 'Learn more',
  },
  NO_PERMISSION: {
    subHeading:
      'You can’t view applications. Your account doesn’t currently have an application manager who can assign you permission to review applications',
    body: 'First, an admin on your account needs to become the application manager. Then, they can assign you permission to access applications. Please reach out to your admin to set up the user permissions.',
  },
} as const;

export const transferRequirements = `
    You can only transfer the application manager role to admins who have provided their name.
    ${' '}
    They’ll have full portfolio access, and renters must be able to see the name of the person viewing applications.
    ${' '}
    To transfer the role, first promote a user to admin and make sure they add their name in their profile page.
`;
